import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 */
export const DeleteDeliveryWarehouseTransferContentType = '' as const;
export type DeleteDeliveryWarehouseTransferRequest = void;
export type DeleteDeliveryWarehouseTransferResponses = LinkCommonErrorResponses & {};
export type DeleteDeliveryWarehouseTransferResponseSuccess = undefined;
export type DeleteDeliveryWarehouseTransferSearchParams = undefined;
export type DeleteDeliveryWarehouseTransferPathParameters = {
    warehouse_id: string;
    transfer_id: string;
};
export const DeleteDeliveryWarehouseTransferUrl = '/delivery/warehouse/{warehouse_id}/transfers/{transfer_id}' as const;
export const DeleteDeliveryWarehouseTransferMethod = 'DELETE' as const;
export const getDeleteDeliveryWarehouseTransferUrl = (params: DeleteDeliveryWarehouseTransferPathParameters) =>
    DeleteDeliveryWarehouseTransferUrl.replace(
        /\{(\w+)\}/g,
        (_match, param: keyof DeleteDeliveryWarehouseTransferPathParameters) => String(params[param])
    );
